module.exports = __webpack_public_path__ + "static/img/android.67507fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/android.png
// module id = cqU+
// module chunks = 1